/** @module root/components/policies/settings */


import * as STATES from './pnp-settings.states';
import * as STATES_DOCUMENT_CATEGORY from './pnp-document-category/pnp-settings-document-category.states';
import * as STATES_APPROVAL_WORKFLOW from './pnp-approval-workflow/pnp-approval-workflow.states';
import * as STATES_COMPLIANCE_REPORT from './pnp-compliance-report/pnp-settings-compliance-report.states';

import { IDS } from './pnp-settings.constants';
import { pnpSettingsDocumentCategory } from './pnp-document-category/pnp-settings-document-category.component';
import { pnpSettingsDocumentCategoryDetails } from './pnp-document-category/details/pnp-document-category-details.component';
import { pnpSettingsDocumentCategoryGrid } from './pnp-document-category/grid/pnp-document-category-grid.component';
import { pnpDocumentTypesDetails } from './pnp-document-type/details/pnp-document-type-details.component';
import { pnpDocumentTypesGrid } from './pnp-document-type/grid/pnp-document-type-grid.component';
import { pnpSettingsApprovalWorkflow } from './pnp-approval-workflow/pnp-approval-workflow.component';
import { pnpSettingsApprovalWorkflowDetails } from './pnp-approval-workflow/details/pnp-approval-workflow-details.component';
import { pnpSettingsApprovalWorkflowGrid } from './pnp-approval-workflow/grid/pnp-approval-workflow-grid.component';
import { pnpSettingsComplianceReportGrid } from './pnp-compliance-report/grid/pnp-settings-compliance-report-grid.component';
import { pnpSettingsComplianceReport } from './pnp-compliance-report/pnp-settings-compliance-report.component';


export const PNP_SETTINGS_MODULE = angular.module(
    'migration.pnp.settings',
    []
).config(['$uiRouterProvider', ({ stateRegistry }) => {
    Object.values({...STATES,...STATES_DOCUMENT_CATEGORY, ...STATES_APPROVAL_WORKFLOW, ...STATES_COMPLIANCE_REPORT}).map(
        state => stateRegistry.register(state)
    );
}]).component({
    pnpDocumentTypesDetails,
    pnpDocumentTypesGrid,
    pnpSettingsDocumentCategory,
    pnpSettingsDocumentCategoryDetails,
    pnpSettingsDocumentCategoryGrid,
    pnpSettingsApprovalWorkflow,
    pnpSettingsApprovalWorkflowDetails,
    pnpSettingsApprovalWorkflowGrid,
    pnpSettingsComplianceReport,
    pnpSettingsComplianceReportGrid
}).run(['$templateCache', ({ put }) => {
    put(IDS.app_policies_settings_document_types_add, '<pnp-settings-document_types-add></pnp-settings-document_types-add>');
    put(IDS.app_policies_settings_document_types, '<pnp-settings-document_types-manage></pnp-settings-document_types-manage>');
    put('app.policies.settings.categories.add.details', '<pnp-settings-document-category-details></pnp-settings-document-category-details>');
    put('app.policies.settings.categories.manage.listing', '<pnp-settings-document-category></pnp-settings-document-category>');
    put('app.policies.settings.categories.manage.details', '<pnp-settings-document-category-details></pnp-settings-document-category-details>');
    put('app.policies.settings.approval_workflows.add.details', '<pnp-settings-approval-workflow-details></pnp-settings-approval-workflow-details>');
    put('app.policies.settings.approval_workflows.manage.listing', '<pnp-settings-approval-workflow></pnp-settings-approval-workflow>');
    put('app.policies.settings.approval_workflows.manage.details', '<pnp-settings-approval-workflow-details></pnp-settings-approval-workflow-details>');
    put('./pnp-approval-workflow-grid-filter.html', require('./pnp-approval-workflow/grid/pnp-approval-workflow-grid-filter.html'));
    put('app.policies.settings.compliance_report.manage.listing', '<pnp-settings-compliance-report></pnp-settings-compliance-report>');
    put('./pnp-settings-compliance-report-grid-filter.html', require('./pnp-compliance-report/grid/pnp-settings-compliance-report-grid-filter.html'));
    put(IDS.app_policies_settings_compliance_report, '<pnp-settings-compliance_report></pnp-settings-compliance_report>');
    
}]);
